/** Partner percents carry at most two decimals. */
export function roundPercent(value: number): number {
  return Math.round(value * 100) / 100
}

export function formatPercent(value: number): string {
  return String(roundPercent(value))
}
